// src/components/Statement/ViewStatement.jsx
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../services/api';
 

const ViewStatement = () => {
  const { userId, userName } = useParams();
  const [statements, setStatements] = useState([]);

  useEffect(() => {
   
    api.get(`/statements/employee/${userId}`).then(res => setStatements(res.data));
  }, [userId]);

  return (
    <div>
      <h2>{userName} | Tour Statements</h2>
      <table>
        <thead>
          <tr><th>No</th><th>Month</th><th>Action</th></tr>
        </thead>
        <tbody>
          {statements.map((s, idx) => (
            <tr key={idx}>
              <td>{idx + 1}</td>
              <td>{s.month}</td>
              <td>
                <button>View Regular</button>
                <button>View FV Based</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default ViewStatement;